// extracted by mini-css-extract-plugin
export var dayLabel = "_kc-0";
export var pickerDisabled = "_kc-1";